import { lazy, Suspense, useEffect, useState } from "react";
import { PublicRequestPage } from "./pages/PublicRequestPage";

const AdminPage = lazy(() => import("./pages/AdminPage").then((module) => ({ default: module.AdminPage })));

function currentPath() {
  return window.location.pathname.startsWith("/admin") ? "/admin" : "/";
}

export default function App() {
  const [path, setPath] = useState(currentPath);

  useEffect(() => {
    const onPopState = () => setPath(currentPath());
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  function navigate(next: string) {
    window.history.pushState({}, "", next);
    setPath(currentPath());
    window.scrollTo({ top: 0 });
  }

  return path === "/admin"
    ? <Suspense fallback={<div className="app-loading"><span className="spinner" /><span>Verwaltung wird geladen …</span></div>}><AdminPage navigate={navigate} /></Suspense>
    : <PublicRequestPage navigate={navigate} />;
}
